"use client";
import { useState } from "react";

export enum ModalState {
  OPEN = "OPEN",
  CLOSE = "CLOSE",
}

export function useModalState(initialState: ModalState = ModalState.CLOSE) {
  const [modalStatus, setModalStatus] = useState<ModalState>(initialState);
  const openModal = () => setModalStatus(ModalState.OPEN);
  const closeModal = () => setModalStatus(ModalState.CLOSE);

  return {
    modalStatus,
    modalIsOpen: modalStatus === ModalState.OPEN,
    modalIsClosed: modalStatus === ModalState.CLOSE,
    openModal,
    closeModal,
  };
}
